// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".a6abaed3bc01162cd5685ce3c0e47c3b42de4c5b.chunk.js";
};